/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerBlender('original', function (imgData, background, cb) {
    var tmpCanvas = document.createElement('canvas'), ctx,
        image = document.createElement('canvas');

    image.width = imgData.width;
    image.height = imgData.height;
    tmpCanvas.width = imgData.width;
    tmpCanvas.height = imgData.height;

    image.getContext('2d').putImageData(imgData, 0, 0);

    ctx = tmpCanvas.getContext('2d');

    ctx.globalCompositeOperation = 'source-over'; // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation

    ctx.drawImage(background, 0, 0);
    ctx.drawImage(image, 0, 0);

    cb(ctx.getImageData(0, 0, imgData.width, imgData.height));
  });
}(FakeCation));
